import React, { useEffect, useState, useRef } from "react";
import "./Productfilter.css";
import { useSelector } from "react-redux";
import {
  ActiveChips,
  BrandList,
  CategoryList,
  GenderList,
  PricePanel,
  SizeGrid,
  SortList,
} from "./FilterControls";
import {
  buildActiveChips,
  filterGenderOptions,
  formatProductCount,
  getSingleSizeGroupLabel,
  sortLabel,
} from "../helper/filterOptions";

export default function Productfilter(props) {
  const containerRef = useRef(null);
  const [short, setShort] = useState(false);
  const [gender, setGender] = useState(false);
  const [category, setCategory] = useState(false);
  const [brand, setBrand] = useState(false);
  const [brendi, setBrendi] = useState(false);
  const [size, setSize] = useState(false);
  const [price, setPrice] = useState(false);
  const [stickyTop, setStickyTop] = useState(0);

  const categoryValue = useSelector((state) => state?.category);
  const catData = categoryValue?.categories?.categoryList || [];

  const isDiscountPage = props.isDiscountPage || false;
  const activeCategories = props.activeCategories || [];
  const activeBrands = props.activeBrands || [];
  const activeSubBrands = props.activeSubBrands || [];
  const activeSizes = props.activeSizes || [];
  const activeGender = props.activeGender;
  const activeSort = props.activeSort || "";
  const activeMinPrice = props.activeMinPrice;
  const activeMaxPrice = props.activeMaxPrice;
  const activeOffer = props.activeOffer || "";
  const genderChoices = filterGenderOptions(props.availableGenders || []);
  const showGender = (props.pageType !== "products" || isDiscountPage) && (
    !props.facetStatus ||
    props.facetStatus === "error" ||
    (props.facetStatus === "ready" && genderChoices.length > 1)
  );
  const showBrands = props.pageType !== "brand";
  const showSubBrands = props.pageType === "brand" && Array.isArray(props.availableSubBrands) && props.availableSubBrands.length > 0;
  const saleOn = String(activeOffer).toLowerCase() === "yes";

  const closeAllDrop = () => {
    setShort(false);
    setGender(false);
    setCategory(false);
    setBrand(false);
    setBrendi(false);
    setSize(false);
    setPrice(false);
  };

  useEffect(() => {
    const syncStickyTop = () => {
      const header = document.querySelector("header.header.scrolling-header");
      const height = header ? Math.round(header.getBoundingClientRect().height) : 0;
      setStickyTop(height);
    };

    syncStickyTop();
    window.addEventListener("scroll", syncStickyTop, { passive: true });
    window.addEventListener("resize", syncStickyTop);
    return () => {
      window.removeEventListener("scroll", syncStickyTop);
      window.removeEventListener("resize", syncStickyTop);
    };
  }, []);

  useEffect(() => {
    const handleOutside = (event) => {
      if (!containerRef.current) return;
      const anyOpen = short || gender || category || brand || brendi || size || price;
      if (anyOpen && !containerRef.current.contains(event.target)) {
        closeAllDrop();
      }
    };

    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
    };
  }, [short, gender, category, brand, brendi, size, price]);

  const setters = {
    short: setShort,
    gender: setGender,
    category: setCategory,
    brand: setBrand,
    brendi: setBrendi,
    size: setSize,
    price: setPrice,
  };

  const toggle = (key) => {
    const current = { short, gender, category, brand, brendi, size, price }[key];
    Object.entries(setters).forEach(([name, set]) => {
      set(name === key ? !current : false);
    });
  };

  const chips = buildActiveChips({
    catData,
    activeCategories,
    activeBrands,
    activeSubBrands,
    activeSizes,
    activeGender,
    activeOffer: isDiscountPage ? "" : activeOffer,
    activeMinPrice,
    activeMaxPrice,
  });

  const removeChip = (chip) => {
    if (chip.kind === "category") props.setCategoryPushData(chip.payload);
    if (chip.kind === "brand") props.setBrandPushData(chip.payload);
    if (chip.kind === "subbrand") props.setSubBrandPushData(chip.payload);
    if (chip.kind === "size") props.setSizePushData(chip.payload);
    if (chip.kind === "gender") props.setGenderPushData(undefined);
    if (chip.kind === "offer") props.setOfferPush(undefined);
    if (chip.kind === "price") props.setPricePushData(undefined, undefined);
  };

  const productCount = formatProductCount(props.productCount);
  const hasBound = (value) => value !== undefined && value !== null && value !== "";
  const priceActive = hasBound(activeMinPrice) || hasBound(activeMaxPrice);

  return (
    <div
      ref={containerRef}
      className="filter-toolbar"
      style={{ "--filter-sticky-top": `${stickyTop}px` }}
    >
      <div className="filter-toolbar__inner container mx-auto">
      <div className="filter-toolbar__row">
        <div className="filter-toolbar__filters">
          <FilterMenu
            label="Kategoritë"
            open={category}
            count={chips.filter((chip) => chip.kind === "category").length}
            onToggle={() => toggle("category")}
            panelClass="filter-panel--wide"
          >
            <CategoryList
              catData={catData}
              activeCategories={activeCategories}
              onToggle={props.setCategoryPushData}
              facetStatus={props.facetStatus}
              availableCategoryIds={props.availableCategoryIds}
            />
          </FilterMenu>

          {showBrands && (
            <FilterMenu
              label="Brendi"
              open={brand}
              count={activeBrands.length}
              onToggle={() => toggle("brand")}
            >
              <BrandList selected={activeBrands} onToggle={props.setBrandPushData} />
            </FilterMenu>
          )}

          {showSubBrands && (
            <FilterMenu
              label="Brendi"
              open={brendi}
              count={activeSubBrands.length}
              onToggle={() => toggle("brendi")}
            >
              <BrandList
                brands={props.availableSubBrands}
                selected={activeSubBrands}
                onToggle={props.setSubBrandPushData}
              />
            </FilterMenu>
          )}

          <FilterMenu
            label="Madhësia"
            open={size}
            count={activeSizes.length}
            onToggle={() => toggle("size")}
            panelClass="filter-panel--wide"
          >
            <SizeGrid
              selected={activeSizes}
              onToggle={props.setSizePushData}
              facetStatus={props.facetStatus}
              availableSizes={props.availableSizes}
              singleGroupLabel={getSingleSizeGroupLabel(catData, activeCategories)}
              sizesByCategory={props.availableSizesByCategory}
              catData={catData}
              activeCategories={activeCategories}
            />
          </FilterMenu>

          <FilterMenu
            label="Çmimi"
            open={price}
            selected={priceActive}
            onToggle={() => toggle("price")}
          >
            <PricePanel
              min={activeMinPrice}
              max={activeMaxPrice}
              onChange={props.setPricePushData}
            />
          </FilterMenu>

          {showGender && (
            <FilterMenu
              label="Gjinia"
              open={gender}
              selected={Boolean(activeGender)}
              onToggle={() => toggle("gender")}
            >
              <GenderList
                activeGender={activeGender}
                onChange={props.setGenderPushData}
                facetStatus={props.facetStatus}
                availableGenders={props.availableGenders}
              />
            </FilterMenu>
          )}

          {!isDiscountPage && (
            <button
              type="button"
              className={`filter-menu__btn ${saleOn ? "has-selection" : ""}`}
              onClick={() => {
                closeAllDrop();
                props.setOfferPush(saleOn ? undefined : "yes");
              }}
            >
              Zbritje
            </button>
          )}
        </div>

        <div className="filter-toolbar__meta">
          {productCount && <span className="filter-count">{productCount}</span>}
          <FilterMenu
            label={`Rendit: ${sortLabel(activeSort)}`}
            open={short}
            onToggle={() => toggle("short")}
            align="end"
          >
            <SortList
              activeSort={activeSort}
              onChange={(value) => {
                const unchanged = value === "newest"
                  ? !activeSort || activeSort === "newest"
                  : activeSort === value;
                if (!unchanged) props.setSortPushData(value);
                setShort(false);
              }}
            />
          </FilterMenu>
        </div>
      </div>

      <ActiveChips
        chips={chips}
        onRemove={removeChip}
        onClear={() => {
          closeAllDrop();
          props.resetFilter();
        }}
      />
      </div>
    </div>
  );
}

function FilterMenu({ label, open, count = 0, selected = false, onToggle, align, panelClass, children }) {
  const marked = selected || count > 0;
  return (
    <div className={`filter-menu ${align === "end" ? "filter-menu--end" : ""}`}>
      <button
        type="button"
        className={`filter-menu__btn ${open ? "is-open" : ""} ${marked ? "has-selection" : ""}`}
        aria-expanded={open}
        onClick={onToggle}
      >
        <span>{count ? `${label} (${count})` : label}</span>
        <span className="filter-menu__caret" aria-hidden="true">{open ? "▴" : "▾"}</span>
      </button>
      {open && <div className={`filter-panel ${panelClass || ""}`}>{children}</div>}
    </div>
  );
}
